<template>
  <div>
    <div v-if="data.confirmationNumber">
      <div class="wizard__graphic">
        <img class="wizard__graphic__img" src="/images/wizard/thanks-graphic-teal.jpg" />
      </div>

      <div class="wizard__text">
        <div v-html="this.copy"></div><br>
        Confirmation #
        <pre>{{ data.confirmationNumber }}</pre>
      </div>

      <ul class="wizard__nav">
        <!-- <li class="wizard__nav__item"><a class="wizard__nav__link wizard__nav__link--previous" @click.prevent="onPrevious">Previous</a></li> -->
        <li class="wizard__nav__item"><a class="wizard__nav__link wizard__nav__link--home" href="/">Return Home</a></li>
      </ul>
    </div>

    <div v-else>
      <div class="spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      copy: {
        type: String,
        required: true
      },

      data: {
        type: Object,
        required: true
      },

      onResponse: {
        type: Function
      },

      onPrevious: {
        type: Function
      },
    },

    data: () => ({

    }),

    computed: {

    },

    methods: {

    }
  };
</script>
